// extracted by mini-css-extract-plugin
export default {"clrBorder":"#ccc","clrWhite":"#fff","root":"DropDownMenu_root__5rDOF","item":"DropDownMenu_item__3b9N8"};